export default __webpack_public_path__ + "static/media/prog5.06d134fb.jpg";